import React, { PureComponent } from 'react';

class TurnkeyUploadLogListHeader extends PureComponent {

    render() {
        
        return (
        	<thead className="table-header">
	            <tr className="table-list-row row-header">
	            	<th className="table-list-col bold" style={{width: '100px'}}>
	            		發票號碼
	            		<div className="fix-row-header">發票號碼</div>
	            	</th>
	            	<th className="table-list-col bold" style={{width: '70px'}}>
	            		期別
	            		<div className="fix-row-header">期別</div>
	            	</th>
					<th className="table-list-col bold" style={{width: '80px'}}>
		            	上傳時間
		            	<div className="fix-row-header">上傳時間</div>
		            </th>
		            <th className="table-list-col bold" style={{width: '140px'}}>
		            	Turnkey XML格式編號
		            	<div className="fix-row-header">Turnkey XML格式編號</div>
		            </th>
	            </tr>
	        </thead>
        );
    }
}

export default TurnkeyUploadLogListHeader;


// WEBPACK FOOTER //
// ./src/components/turnkeyuploadlog/TurnkeyUploadLogListHeader.jsx